import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { HelperService } from 'src/app/shared/services/helper/helper.service';
import { FaqService } from 'src/app/shared/services/faq/faq.service';
import { FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'src/app/validators/customValidator';
import { IssueTypesComponent } from '../issue-types/issue-types.component';
import { IssueService } from 'src/app/shared/services/issue/issue.service';
import { CommonConstants } from 'src/app/shared/common-constants';

@Component({
  selector: 'app-issue-type-dialog',
  templateUrl: './issue-type-dialog.component.html',
  styleUrls: ['./issue-type-dialog.component.scss'],
})
export class IssueTypeDialogComponent implements OnInit {
  public action: string = 'Add';
  public local_data: any;
  public selectedImage: any = '';
  public addIssueTypeForm: any;
  public isProcessing = false;

  constructor(
    public datePipe: DatePipe,
    public dialogRef: MatDialogRef<any>,
    private helperService: HelperService,
    private issueService: IssueService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: IssueTypesComponent
  ) {
    this.local_data = { ...data };
    this.action = this.local_data.action ? this.local_data.action : 'Add';
  }
  ngOnInit() {
    this.resetAddContentForm();
  }

  // convenience getter for easy access to form fields
  get addIssyeTypeControls() {
    return this.addIssueTypeForm.controls;
  }

  resetAddContentForm() {
    this.addIssueTypeForm = this.fb.group({
      name: [
        null,
        Validators.compose([
          Validators.required,
          CustomValidators.noWhitespaceValidator,
          ,
          Validators.maxLength(CommonConstants.maxLength60),
        ]),
      ],
    });
  }

  async doAction() {
    await this.submitIssueTypeForm();
  }

  closeDialog(): void {
    this.dialogRef.close({ event: 'Cancel' });
  }

  async submitIssueTypeForm() {
    if (this.action === 'Delete') {
      try {
        this.isProcessing = true;
        const deleteURL = `issueTypeId=${this.local_data.id}`;
        const res = await this.issueService.removeIssueType(deleteURL);
        if (res) {
          this.helperService.showAlert(res.msg || 'Success', 'success');
        }
        this.dialogRef.close({
          event: this.action,
          data: this.local_data,
          success: true,
        });
      } catch (err: any) {
        this.helperService.showAlert(
          err.error || 'Something went wrong',
          'error'
        );
        this.dialogRef.close({
          event: this.action,
          data: this.local_data,
          success: false,
        });
      } finally {
        this.isProcessing = false;
      }
    } else {
      if (this.addIssueTypeForm.valid) {
        try {
          this.isProcessing = true;
          const reqData: any = {
            name: this.local_data.name,
          };
          if (this.action === 'Update') {
            reqData['issueTypeId'] = this.local_data.id;
          }
          let res: any;
          if (this.action === 'Add') {
            res = await this.issueService.addIssueType(reqData);
            this.local_data.id = res.data.id;
            this.local_data.createdAt = res.data.createdAt;
          } else if (this.action === 'Update') {
            res = await this.issueService.updateIssueType(reqData);
          }
          if (res) {
            this.helperService.showAlert(res.msg || 'Success', 'success');
          }
          this.dialogRef.close({
            event: this.action,
            data: this.local_data,
            success: true,
          });
        } catch (err: any) {
          this.helperService.showAlert(
            err.error || 'Something went wrong',
            'error'
          );
        } finally {
          this.isProcessing = false;
        }
      }
    }
  }
}
